<template>
<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     viewBox="0 0 300 300" style="enable-background:new 0 0 300 300;" xml:space="preserve">

<g>
    <path class="st0" d="M126.5,9H15.7C12,9,9,12,9,15.7v110.8c0,3.7,3,6.7,6.7,6.7h110.8c3.7,0,6.7-3,6.7-6.7V15.7
        C133.2,12,130.2,9,126.5,9L126.5,9z M109.9,109.9H32.3V32.3h77.6L109.9,109.9z"/>
    <path class="st0" d="M284.3,9H173.5c-3.7,0-6.7,3-6.7,6.7v110.8c0,3.7,3,6.7,6.7,6.7l110.8,0c3.7,0,6.7-3,6.7-6.7l0-110.8
        C291,12,288,9,284.3,9L284.3,9z M268,110.2h-78.2V32H268L268,110.2L268,110.2z"/>
    <path class="st0" d="M126.5,166.8H15.7c-3.7,0-6.7,3-6.7,6.7l0,110.8c0,3.7,3,6.7,6.7,6.7h110.8c3.7,0,6.7-3,6.7-6.7l0-110.8
        C133.2,169.8,130.2,166.8,126.5,166.8z M109.9,267.7H32.3v-77.6h77.6L109.9,267.7z"/>
    <path class="st0" d="M284.3,166.8H173.5c-3.7,0-6.7,3-6.7,6.7v110.8c0,3.7,3,6.7,6.7,6.7l110.8,0c3.7,0,6.7-3,6.7-6.7l0-110.8
        C291,169.8,288,166.8,284.3,166.8L284.3,166.8z M268,268h-78.2v-78.2H268L268,268L268,268z"/>
</g>
</svg>
</template>

<script>
export default {
    name: 'IconDashboard',
}
</script>

<style lang="scss" scoped>
</style>